<template>
    <div class="user-submission-details">
        <transition name="fade">
            <Notifications
                v-if="notificationData && !modalStatus"
                :msg-type="notificationData.type"
                :msg-text="notificationData.text"
            />
        </transition>
        <div class="user-info-wrapper">
            <div class="id-bar">
                <div class="user-id">
                    <div class="name-bar">
                        <h3 class="submission-title user-name"> {{ submissionName }} </h3>
                        <a v-if="socialLink" :href="socialLink" :title="submissionName" :aria-label="submissionName" target="_blank">
                            <i :class="socialIcon" />
                        </a>
                        <Popper v-if="!webShareApiAvailable"
                            position="bottom-end"
                            trigger="clickToToggle"
                            id="pastimeShareId"
                            class="pastime-share-link ml-auto"
                            @input="toggleShareUrl">
                            <span slot="activator" class="sp-participant-link">
                                <i class="ecom-link prz-link-share"/>
                            </span>
                            <CopyToClipboard v-if="shareUrl" :coupon-text="true" :value="shareUrl" :kStrings="kStrings" class="share-link-box"/>
                        </Popper>
                        <span v-else class="ml-auto sp-parcipant-link" @click="loadWebShareApi()">
                            <i class="ecom-link prz-link-share"/>
                        </span>
                    </div>
                    <p class="country-id"> {{ submissionCountry }} </p>
                </div>
            </div>
            <div v-if="rankingLabel" class="ranking-bar stacked-bar" :class="rankingCssClass">
                <span v-if="submissionPlaceString" class="ranking-description"> 
                     <i class="ecom-trophy"/> {{ rankingLabel }}
                </span>
                <span class="ranking-likes"> <i class="ecom-favourite-full"/> {{ baseVotes }} </span>
            </div>
            <div v-else class="ranking-bar">
                <span v-if="submissionPlaceString" class="ranking-description">{{ submissionPlaceString }}</span>
                <span class="ranking-likes"> <i class="ecom-favourite-full"/> {{ baseVotes }} </span>
            </div>
        </div>
       <div class="button-wrapper" :class="{'has-warning' : voteMotive}">
           <button class="pastime-button red-theme" @click="!voteButtonDisabled && voteHandler()" :disabled="voteButtonDisabled">
               <i :class="[hasVote ? 'ecom-favourite-full' : 'ecom-favourite-line']"/> 
               {{ !hasVote ? kStrings.kLIKE : kStrings.kLIKED }}
           </button>
           <p v-if="voteMotive" class="participation-warning">
               <!-- <Popper v-if="voteMotive.popupMsg" position="top"
                       trigger="clickToToggle"
                       id="participationWarningId"
                       class="participation-warning-popup">
                   <i slot="activator" class="ecom-info"/>
                   {{ voteMotive.popupMsg }}
               </Popper>-->
               <i class="ecom-info"/>
               <span class="warning-msg"> {{ voteMotive.popupMsg ? voteMotive.popupMsg : voteMotive.warningMsg }} </span>
           </p>
           <p class="important-info">
               <i class="ecom-info"/>
               {{ kStrings.kEVT_LIMIT_DATE_VOTING + ': ' }} <span> {{ pastimeInfo.detailedInfo.votingEndDate }} </span>
           </p>
       </div>
       <MuffinLoader v-if="showLoader" />
    </div>
</template>

<script>

import {store} from '@/store/pastimes';
//import GeneralModal from '@/components/Pastimes/Desktop/partials/GeneralModal';
import CopyToClipboard from '@/components/Muffin/CopyToClipboard';
import Notifications from '@/components/Pastimes/Desktop/partials/Notifications';

import sharedApi from '@/api/sharedApi';
import request from '@/Utilities/httpRequest';

import FanLink from '@/components/ProductPage/FanLink';
import Popper from '@/components/Muffin/Popper';
import MuffinLoader from '@/components/Muffin/Loader';
import {isEmpty} from 'lodash-es';

//import {UserId} from '../../../../../../../../../src-js/user-id';
import browserId from '../../../../../../../../../src-js/browser-id';

export default {
    store,
    name: 'SubmissionDetails',
    components: {
        FanLink,
        Popper,
        CopyToClipboard,
        Notifications,
        MuffinLoader
    },
    props: {
        //prop1: {type: Object, default: null, required: false}
    },
    data() { 
        return {
            voteFromWS: false,
            baseVotes: 0,
            shareUrl: null,
            showLoader: false,
            browserId: null,
            browserIdBackend: false,
        }
    },
    computed: {
        socialLink(){
            let link = this.socialInfo?.link ?? null;
            if(!link){
                return null;
            }
            if(!link.includes("https://")) {
                link = 'https://' + link;
            }
            return link;
        },
        isLogged() {
            return this.$store.getters.isLogged;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        isDesktop() {
            return this.$store.getters.isDesktop;
        },
        urls() {
            return this.$store.getters.urls;
        },
        notificationData() {
            return this.$store.getters['contestantPage/notificationData'];
        },
        pastimeInfo() {
            return this.$store.getters.pastimeInfo;
        },
        validPhone() {
            return this.$store.getters.validPhone;
        },
        voteValidation(){
            return this.$store.getters['contestantPage/voteValidation'];
        },
        requirePhoneValidationToVote() {
            return this.voteValidation?.phoneValidation ?? false;
        },
        requireSMSValidation() {
            return this.requirePhoneValidationToVote && !this.validPhone;
        },
        registrationInfo() {
            return this.$store.getters['contestantPage/registrationInfo'];
        },
        submissionName() {
            if(this.registrationInfo.name) {
                return this.registrationInfo.name;
            }
            
            return this.registrationInfo.participantName;
        },
        submissionCountry() {
            return this.registrationInfo.country;
        },
        submissionVotes() {
            return this.registrationInfo.votes;
        },
        submissionRanking() {
            return this.registrationInfo.ranking;
        },
        rankingLabel() {
            return this.registrationInfo.rankingLabel;
        },
        rankingCssClass() {
            return this.registrationInfo.rankingCssClass;
        },
        hasEnded() {
            return this.pastimeInfo.detailedInfo.hasEnded;
        },
        canVote() {
            if(!this.hasEnded && !this.isLogged) {
                // user not logged, allow "click" to trigger login/register
                return true;
            }
            return this.voteValidation?.canVote ?? false;
        },
        hasVote(){
            return this.voteValidation?.alreadyVoted ?? false;
        },
        submissionPlaceString() {
            let parsed = '';
            if(!this.submissionRanking){
                return parsed;
            }
            let positionString = this.kStrings.kPLACE_POSITION;
            switch (this.submissionRanking) {
                case 1:
                    parsed = this.kStrings.kFIRST_PLACE;
                    break;
                case 2:
                    parsed = this.kStrings.kSECOND_PLACE;
                    break;
                case 3:
                    parsed = this.kStrings.kTHIRD_PLACE;
                    break;
                default:
                    parsed = this.submissionRanking + 'º';
            }
            
            return `${parsed} ${positionString}`;
        },
        modalStatus() {
            return this.$store.getters.modalStatus;
        },
        socialInfo() {
            if(isEmpty(this.registrationInfo.socialInfo) || this.registrationInfo.socialInfo.type == 'linkoff') {
                return null
            }
            
            return this.registrationInfo.socialInfo;
        },
        socialIcon() {
            let cssClass = 'ecom-fan-link';
            if(!this.socialInfo) {
                return cssClass;
            }
            
            switch(this.socialInfo.type) {
                case 'fb':
                    cssClass = 'ecom-facebook'
                    break;
                case 'tk':
                    cssClass = 'ecom-tiktok';
                    break;
                case 'itg':
                    cssClass = 'ecom-instagram'
                    break;
                case 'yt':
                    cssClass = 'ecom-youtube'
                    break;    
                case 'ptr':
                    cssClass = 'ecom-pinterest'
                    break; 
                case 'twt':
                    cssClass = 'ecom-twitter'
                    break;
                default:
                    break;
            }

            return cssClass;
            
        },        
        voteMotive() {
            if(this.canVote) {
                return null;
            }

            let motive = this.voteValidation?.motive ?? null;
            
            return motive ? {
                popupMsg: motive,
                warningMsg: this.kStrings.kCANT_VOTE_PASTIME_FOR_NOW
            } : null;
        },
        webShareApiAvailable(){
            return sharedApi.checkWebShareApi;
        },
        voteButtonDisabled(){
            if(!this.canVote){
                // user cannot vote check if "phone validation" is required
                // and enable button click to trigger it
                return !this.requirePhoneValidationToVote;
            }
            return false;
        }
    },
    watch: {
        browserId(value){
            console.log('watch browserId', value, this.browserIdBackend)
            if(value && this.browserIdBackend === false){
                browserId.sendId();
                this.browserIdBackend = true;
            }
        }
    },
    created() {
    },
    mounted() {
        this.$nextTick(() => {
            if(!this.requirePhoneValidationToVote) {
                this.$store.dispatch('setValidPhone', true);
            }
            
            this.baseVotes = this.submissionVotes;
            console.log('this.registrationInfo.hasBrowserId', this.registrationInfo.hasBrowserId ? 'ok' : 'ko');
            this.browserIdBackend = this.registrationInfo.hasBrowserId;
        });
        browserId.getId().then((res) => {this.browserId = res; });
    },
    methods: {
        async submitVote() {
            if (!this.isLogged && typeof accountAuth.openLogin === 'function') {
                let params = {
                    loginMessage: 'kINFO_LOGIN_PASTIME',
                };
                accountAuth.openLogin(params);
            } else {
                // darkness and ignorance take you all
                //this.modalControl(true, 'smsValidation');
                this.$store.dispatch('setLoading', true);
                try {
                    let params = {
                        registrationId: this.registrationInfo.registrationId,
                        socialPastimeId: this.pastimeInfo.baseInfo.id,
                        fp: this.browserId,
                    };
                    
                    const {data} = await request.post(this.urls.votePastime, params, false);
                    let hasError = data.hasError || !data.voteId;
                    if(!hasError) {
                        this.voteFromWS = true;
                        this.baseVotes+=1;
                        this.$store.dispatch('contestantPage/setVoteValidation', data.voteValidation);
                        this.$store.dispatch('contestantPage/loadNotification', {
                            type: 'success',
                            text: this.kStrings.kPASTIME_VOTE_SUCCESS,
                            duration: 6000
                        });
                    } else {
                        this.$store.dispatch('contestantPage/loadNotification', {
                            type: 'error',
                            text: this.kStrings.kGLOB_ERROR_MSG,
                            duration: 6000
                        });
                    }
                } catch (e) {
                    sharedApi.logError(e);
                    this.$store.dispatch('contestantPage/loadNotification', {
                        type: 'error',
                        text: this.kStrings.kGLOB_ERROR_MSG,
                        duration: 10000
                    });
                } finally {
                    this.$store.dispatch('setLoading', false);
                }
            }
        },

        // a little "repetition"....
        modalControl(status = false, context = '') {
            this.$store.dispatch('setModalStatus', {status: status, context: context});
        },
        voteHandler() {
            if(this.isLogged) {
                if (this.requireSMSValidation) {
                    this.modalControl(true, 'smsValidation');
                } else {
                    this.submitVote();
                }
            } else {
                if(this.isDesktop) {
                    accountAuth.openLogin();
                } else {
                    window.location.assign(this.urls.login);
                }
            }
        },
        async toggleShareUrl(visible){
            if(visible && !this.shareUrl){
                this.showLoader = true;
                const params = {
                    challengeId: this.registrationInfo.pastimeId,
                    registrationId: this.registrationInfo.registrationId,
                }
                const {data} = await request.get(this.urls.getShortUrl, params, false);
                if(data && data.url){
                    this.shareUrl = data.url;
                }
                this.showLoader = false;
            }
        },
        async loadWebShareApi() {
            if(this.webShareApiAvailable) {
                await this.toggleShareUrl(true);
                
                navigator.share({
                    title: this.submissionName,
                    url: this.shareUrl
                });
            }
        },
    }
};
</script>

<style scoped>

</style>